import React,{useState} from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Col,Modal,Row } from 'react-bootstrap';
import packageListingStyles from './packageListing.module.scss';
import Feedback from 'components/Workspace/Feedback';
import OfferPopup from 'components/Workspace/OfferPopup';

const PackageMain = (props) => {
  const [displayThanksPage, setThanksPageValue] = useState(false)
  return (

    <Row>
         {props.isFeedbackPopupShow && <Feedback isFeedbackPopupShow={props.isFeedbackPopupShow} setIsFeedbackPopupShow ={props.setIsFeedbackPopupShow} isFeedbackPopupSource={props.isFeedbackPopupSource} isFeedbackCapturedAt={props.isFeedbackCapturedAt} setThanksPageValue={setThanksPageValue} pageName={"WORKSPACE"}/>}
          { <OfferPopup setIsOfferPopupShow={props?.setIsOfferPopupShow}/>}
          <Modal
      style={{zIndex:"99999"}}
        show={displayThanksPage}
        onHide={() => {
          setThanksPageValue(false);
        }}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body >
        <h3 style={{fontSize:'22px'}}>Thanks for sharing your feedback with us. <br/>Have a good day.</h3>
        </Modal.Body>
      </Modal>
      <Col lg={3}>
        <nav className={packageListingStyles['package-list-Navbar']}>
          <ul
          //   style={{ paddingLeft: '0' }}
          >
            <p>
              <Link
                to="/package-listing/packages"
                className={packageListingStyles['package-list-link']}
              >
                Packages
              </Link>
            </p>
          </ul>
        </nav>
      </Col>
      <Col lg={9}>
        <Outlet />
      </Col>
    </Row>
  );
};

export default PackageMain;
